module.exports = __webpack_public_path__ + "img/icons_UI_icon_wrong.02a9a0b5.svg";